import { gql } from '@apollo/client';

export const RefreshToken = gql`
  mutation refreshToken($token: String!) {
    refreshToken(token: $token) {
      access_token
      refresh_token
    }
  }
`;
